export default __webpack_public_path__ + "static/media/img5pic2.70fb1ba0.png";